import { ColumnsType } from "antd/es/table";
import AntTable from "../../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Modal, Popconfirm, Space, Tag, Tooltip, notification } from "antd";
import { useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
// import CreateAffiliate from "./CreateAffiliate";
import { AffiliateService } from "../../../services/AffiliateService";
import Filter from './Filter';

export default function Payment() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [filters, setFilters] = useState<any>()

    const columns: ColumnsType<any> = [
        {
            title: 'วันที่ทำรายการ',
            align: 'center',
            dataIndex: 'trx_created_date',
            key: 'trx_created_date',
            render: (value, record) => {
                return moment(value).format('DD-MM-YYYY HH:mm')
            },
        },
        // {
        //     title: 'Client Member Id',
        //     align: 'center',
        //     dataIndex: 'client_member_id',
        //     key: 'client_member_id',
        //     render: (value, record) => {
        //         return `${value} ${record?.user_id}`
        //     }
        // },
        {
            title: 'Transaction ID',
            align: 'center',
            dataIndex: 'transaction_id',
            key: 'transaction_id'
        },
        {
            title: 'Client Phone Number',
            align: 'center',
            dataIndex: 'client_phone_no',
            key: 'client_phone_no',
            render: (value, record) => {
                return <Tooltip title={`Client Member Id: ${record.client_member_id}`}>{value}</Tooltip>
            }
        },
        {
            title: 'Pay To Phone Number',
            align: 'center',
            dataIndex: 'pay_to_tel',
            key: 'pay_to_tel',
            render: (value, record) => {
                return <Tooltip title={`Client Member Id: ${record.pay_to_unique_id}`}>{value}</Tooltip>
            },
        },
        {
            title: 'Send Amount',
            align: 'center',
            dataIndex: 'send_amount',
            key: 'send_amount',
            render: (value, record) => {
                return `${value} ${record?.send_currency}`
            }
        },
        {
            title: 'Receive Amount',
            align: 'center',
            dataIndex: 'receive_amount',
            key: 'receive_amount',
            render: (value, record) => {
                return `${value} ${record?.receive_currency}`
            }
        },
        {
            title: 'Fee',
            align: 'center',
            dataIndex: 'fee',
            key: 'fee'
        },
        {
            title: 'สถานะการโอน',
            align: 'center',
            dataIndex: 'transaction_status',
            key: 'transaction_status',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'วันที่ทำการคำนวณ',
            align: 'center',
            dataIndex: 'cal_date',
            key: 'cal_date',
            render: (value, record) => {
                return moment(value).format('DD-MM-YYYY')
            },
        },
        {
            title: 'ระดับ',
            align: 'center',
            dataIndex: 'affiliate_level_name',
            key: 'affiliate_level_name',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'ค่า Commission',
            align: 'center',
            sorter: true,
            dataIndex: 'commission_baht',
            key: 'commission_baht',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'ค่า Commission ของ Top Agent',
            align: 'center',
            sorter: true,
            dataIndex: 'top_agent_commission_baht',
            key: 'top_agent_commission_baht',
            render: (value, record) => {
                return value
            },
        },
        // {
        //     title: 'วันที่ทำการจ่าย',
        //     align: 'center',
        //     dataIndex: 'pay_date',
        //     key: 'pay_date',
        //     render: (value, record) => {
        //         return moment(value).isValid() ? moment(value).format('DD-MM-YYYY') : null
        //     },
        // },

    ];


    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
            ...filters
        }
        const res = await AffiliateService.getAffiliatePayments(payload)
        return res
    }

    const generateReport = async () => {
        const res = await AffiliateService.generateAffiliatePayments(filters)
        setRefreshData(p => !p)
    }

    // const onStatusChange = async (id: number, status: 'approve' | 'progress' | 'reject') => {

    //     const data = {
    //         id: id,
    //         status: status
    //     }
    //     const res = await AffiliateService.changeStatus(data)

    //     if (res.status == 1) {
    //         notification.open({
    //             type: 'success',
    //             message: res.status_detail,
    //             placement: 'top'
    //         });
    //         setRefreshData(p => !p)
    //     } else {
    //         notification.open({
    //             type: 'error',
    //             message: res.status_detail,
    //             placement: 'top'
    //         });
    //     }
    // }

    const onFilters = (data: object) => {
        setFilters(data)
        setRefreshData(p => !p)
    }



    return (
        <>
            {/* <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateAffiliate
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateAffiliate>
            </Modal> */}
            <AntTable
                Filter={<Filter setFilters={onFilters} />}
                refresh={refreshData}
                menuOptions={[{
                    label: <Popconfirm
                        title={`ยืนยันที่จะทำการ Generate ข้อมูลใหม่ โดยข้อมูลเก่าของเดือน ${filters?.month} จะถูกเขียนทับ ?`}
                        okText="ใช่"
                        cancelText="ไม่"
                        onConfirm={() => generateReport()}
                    >
                        Click for summary report
                    </Popconfirm >,
                    key: 'generate_report'
                }]}
                menuClick={(e) => {
                    if (e.key == 'generate_report') {

                    }
                }}
                search
                title="Manage Payment"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
